import { render, staticRenderFns } from "./MasterPersediaan.vue?vue&type=template&id=b422e63c&"
import script from "./MasterPersediaan.vue?vue&type=script&lang=js&"
export * from "./MasterPersediaan.vue?vue&type=script&lang=js&"
import style0 from "./MasterPersediaan.vue?vue&type=style&index=0&id=b422e63c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports